import { Skeleton } from "@nexus/ui";
import { useTranslation } from "react-i18next";

/** Per-tab paging state the hub passes down from its infinite queries. */
export interface OpportunityHubListState {
  isLoading?: boolean;
  isLoadingMore?: boolean;
  hasMore?: boolean;
  onLoadMore?: () => void;
}

export const EMPTY_OPPORTUNITY_HUB_LIST_STATE: OpportunityHubListState = {};

/**
 * Empty and first-load status for a hub tab. Further pages are requested by the
 * tab's virtualizer, which only fires once the loaded end is in the scroll window.
 */
export function OpportunityHubListFooter({
  state,
  isEmpty,
  emptyLabel,
}: {
  state: OpportunityHubListState;
  isEmpty: boolean;
  emptyLabel: string;
}) {
  const { t } = useTranslation();
  const { isLoading, isLoadingMore } = state;

  if (isLoading) {
    return (
      <div role="status" className="flex flex-col gap-2 px-4 py-4">
        <span className="sr-only">{t("common.loading")}</span>
        {Array.from({ length: 6 }, (_, index) => (
          <Skeleton key={index} className="h-10 w-full" />
        ))}
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div className="flex items-center justify-center py-10 text-[13px] text-muted-foreground">
        {emptyLabel}
      </div>
    );
  }

  if (!isLoadingMore) return null;

  return (
    <div role="status" className="px-4 py-3">
      <span className="sr-only">{t("common.loading")}</span>
      <Skeleton className="h-10 w-full" />
    </div>
  );
}
